import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { useResizeDetector } from 'react-resize-detector';
import useSizeDetector from './useSizeDetector.js';

var _global$window;
var supportsResizeObserver = Boolean((_global$window = global.window) === null || _global$window === void 0 ? void 0 : _global$window.ResizeObserver);
var useResizeDetectorOrJustFakeIt = supportsResizeObserver ? useResizeDetector : useSizeDetector;

/**
 *  With dimensions will not render the provided Component unless the height/width can be determined via
 * a reference element, or if a default height/width are provided.
 *
 * @param {ReactComponent} Component
 * @param {Object} Options
 * @param {Number} Options.defaultHeight A default height property if the size has yet to be determined
 * @param {Number} Options.defaultWidth A default width property if the size has yet to be determined
 * @returns {function(*): *}
 */
var withDimensions = function withDimensions(Component, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    defaultWidth = _ref.defaultWidth,
    defaultHeight = _ref.defaultHeight;
  return function WithDimensions(props) {
    var _useResizeDetectorOrJ = useResizeDetectorOrJustFakeIt({
        refreshMode: 'debounce',
        refreshRate: 250
      }),
      width = _useResizeDetectorOrJ.width,
      height = _useResizeDetectorOrJ.height,
      ref = _useResizeDetectorOrJ.ref;
    var shouldRenderComponent = defaultWidth || defaultHeight || width || height;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        width: '100%',
        height: '100%'
      },
      ref: ref
    }, shouldRenderComponent && /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      containerWidth: width !== null && width !== void 0 ? width : defaultWidth,
      containerHeight: height !== null && height !== void 0 ? height : defaultHeight
    })));
  };
};
var withDimensions$1 = withDimensions;

export { withDimensions$1 as default };
